
  import { Vue, Component, Prop, Watch, Model } from "vue-property-decorator";
  import moment from "moment";

  import PageHeadIcon from "@/components/page/PageHeadIcon.vue";
  import PageHeadContainer from "@/components/page/PageHeadContainer.vue";
  import UiButton from "@/components/button/ui-button.vue";
  import ClockIcon from "@/components/icons/ClockIcon.vue";
  import CalendarIcon from "@/components/icons/CalendarIcon.vue";
  import LocationIcon from "@/components/icons/LocationIcon.vue";
  import UserIcon from "@/components/icons/UserIcon.vue";
  import TagIcon from "@/components/icons/TagIcon.vue";
  import GroupsIcon from "@/components/icons/GroupsIcon.vue";
  import CardInfoChip from "@/components/card/CardInfoChip.vue";

  import { Custom_Request } from "@/generated/graphql"; 

  @Component({
    components: {
      PageHeadIcon,
      PageHeadContainer,
      UiButton,
      ClockIcon,
      CalendarIcon,
      LocationIcon,
      UserIcon,
      CardInfoChip,
      TagIcon,
      GroupsIcon
    },
  })
  export default class RequestHeader extends Vue {
    @Prop({ type: Object, required: true }) readonly request!: Custom_Request;
    @Prop({ type: String, required: true }) readonly userRole!: string;
  @Model('toggle', {type: Boolean, default: false}) readonly modalShown!: boolean;

    statusProcessing: boolean = false;

    get period(): string {
      const startDate = moment(this.request.from_date).format("DD MMM");
      const endDate = moment(this.request.to_date).format("DD MMM");
      return `${startDate} - ${endDate}`;
    }

    get requestStatus(): string {
      const str = this.request[0].status;

      let statusParts = str.split('_');
      let statusPartsUpper = statusParts.map(element => {
        let str = element.charAt(0).toUpperCase() + element.slice(1);
        return str;
      });
      return statusPartsUpper.join(' ');
    }

    get requestTag() : string {
      if (!this.request[0].tag) {
        return undefined;
      }
      return this.request[0].tag.name;
    }
    
    get isAdmin(): boolean {
      return this.userRole.toUpperCase() === "ADMIN";
    }

    get isContractor(): boolean {
      return this.userRole === "CONTRACTOR";
    }

    get isActionsShown(): boolean {
      return !this.isContractor;
    }
 

    get manager(): string {
      const firstName = this.request[0].created_by.given_name;
      const lastName = this.request[0].created_by.family_name;
      const title = "Manager:"

      if (!firstName && !lastName) {
        return `${title} -`;
      }

      return `${title} ${firstName} ${lastName}`;
    }

    @Watch("projectCompleted")
    onProjectStatusChanged(): void {
      this.statusProcessing = false;
    }

    completeProject(): void {
      this.$confirm({
        title: `Do you really want to complete the project?`,
        message: `All activities will be closed if you complete this project`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: async (confirm: any) => {
          if (confirm) {
            this.$emit("updateProjectStatus", { completed: true, active: false });
            this.statusProcessing = true;
          }
        },
      });
    }

    reopenProject(): void {
      this.$emit("updateProjectStatus", { completed: false, active: true });
      this.statusProcessing = true;
    }
    toggleRequestModal(): void {
    this.$emit('toggle', !this.modalShown)
  }
  
  }
